

export const CONFIRM_TYPE_SMS_CODE = 1; // подтверждение через смс код
export const CONFIRM_TYPE_USER_CALL = 2; // подтверждение через звонок от пользвоателя
export const CONFIRM_TYPE_BOT_CALL = 3; // подтверждение через звонок от бота, код в номере телефона входящего звонка
export const CONFIRM_TYPE_BOT_SPEECH = 4; // подтверждение через голосовой код

export const ACTION_TYPE_AUTH = 'AUTH'; // Авторизация
export const ACTION_TYPE_REG = 'REG'; // Регистрация
export const ACTION_TYPE_FORGET = 'FORGET'; // Востановление доступа


export default {
    CONFIRM_TYPE_SMS_CODE,
    CONFIRM_TYPE_USER_CALL,
    CONFIRM_TYPE_BOT_CALL,
    CONFIRM_TYPE_BOT_SPEECH,

    ACTION_TYPE_AUTH,
    ACTION_TYPE_REG,
    ACTION_TYPE_FORGET,
}